const setup = () => {
  const KEY = "cjQ9X62xBGw"

  try {
    /* eslint-disable */
    ;(function (c, o, v, i, e, w) {
      c[v] =
        c[v] ||
        function () {
          ;(c[v].a = c[v].a || []).push(arguments)
        }
      var s = o.createElement(i)
      s.src = e
      s.async = 1
      var h = o.getElementsByTagName(i)[0]
      h.parentNode.insertBefore(s, h)
      c.addEventListener("error", function (err) {
        c[v]("error", err)
      })
      c.addEventListener("message", function (msg) {
        c[v]("message", msg)
      })
    })(window, document, "coview", "script", "https://cdn.coview.com/coview.js")
    // Use setTimeout to defer the call until coview script has had time to load
    setTimeout(() => {
      if (typeof (window as any).coview === "function") {
        ;(window as any).coview("start", {
          projectKey: KEY
        })
      }
    }, 100)
    /* eslint-enable */
  } catch (err) {
    // Silently fail if coview setup encounters an error
    console.debug("Coview setup error:", err)
  }
}

export default {
  setup
}
